import { createSelector } from '@reduxjs/toolkit';
import { Person, PersonState } from './types';

const selectPersonBase = createSelector(
	(state: RootState) => state,
	(state: RootState) => state.personReducer,
);

export const selectPersons = createSelector(
	selectPersonBase,
	(state: PersonState) => state.persons,
);

export const selectPersonBookList = createSelector(
	selectPersonBase,
	(state: PersonState) => state.personBookList,
);

export const selectPersonsMap = createSelector(
	selectPersonBase,
	(state: PersonState): Map<string, Person> => {
		const personsMap = new Map<string, Person>();

		state.personBookList.forEach(person => {
			personsMap.set(String(person.id), person);
		});

		return personsMap;
	},
);

export const selectPersonListLoader = createSelector(
	selectPersonBase,
	(state: PersonState) => state.loading,
);

export const selectPersonsError = createSelector(
	selectPersonBase,
	(state: PersonState) => state.error,
);

export const selectPersonId = createSelector(
	selectPersonBase,
	(state: PersonState) => state.selectedPersonId,
);

export const selectPerson = createSelector(
	selectPersonBase,
	(state: PersonState) => state.selectedPerson,
);

export const selectPersonLoader = createSelector(
	selectPersonBase,
	(state: PersonState) => state.isLoadingPerson,
);

export const selectPersonError = createSelector(
	selectPersonBase,
	(state: PersonState) => state.errorPerson,
);

export const selectDefaultPerson = createSelector(
	selectPersonBase,
	(state: PersonState) => state.defaultPerson,
);
